var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Grid, Table, Tooltip, Typography } from 'antd';
import { useEffect, useState } from 'react';
import '../../App.css';
import Modal from 'antd/es/modal/Modal';
import { getServiceSampleInfo, getBOMServiceDocTypes } from '../../services/projectService';
import WatermarkComponent from '../common/watermark';
import { Link } from 'react-router-dom';
const BOMDataTable = ({ data, tableDataItem, loading, pagination, onChange }) => {
    const [tableData, setTableData] = useState([]);
    const [dtModalVisible, setDtModalVisible] = useState(false);
    const [dtModalData, setDtModalData] = useState([]);
    const [sampleInfoModalData, setSampleInfoModalData] = useState([]);
    const [siModalVisible, setSiModalVisible] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    useEffect(() => {
        if (data) {
            const newData = data.map((item, index) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                return {
                    key: index,
                    certificatename: `${item.strServiceName}`,
                    servicetype: `${(_a = item.objLuServiceCode) === null || _a === void 0 ? void 0 : _a.strLongDesc}`,
                    region: `${(_b = item.objLuRegion) === null || _b === void 0 ? void 0 : _b.strLongDesc}`,
                    country: `${(_c = item.objLuCountry) === null || _c === void 0 ? void 0 : _c.strLongDesc}`,
                    productsegment: `${(_d = item.objLuProductMainType) === null || _d === void 0 ? void 0 : _d.strLongDesc}/${(_e = item.objLuProductType) === null || _e === void 0 ? void 0 : _e.strLongDesc}`,
                    technology: `${(_f = item.objLuTechnologyType) === null || _f === void 0 ? void 0 : _f.strLongDesc}`,
                    certificatetype: `${(_g = item.objLuCertificationType) === null || _g === void 0 ? void 0 : _g.strLongDesc}`,
                    sampleinfo: `${item.boolSampleInfoAvail ? 'View Details' : 'Not Required / Exempt'}`,
                    reqdoctype: `${item.boolDocumentTypeAvail ? 'View Documents' : 'Not Required / Exempt'}`,
                    reqsummary: `${item.strRegulationId == null && ((_h = item.objLuCertificationType) === null || _h === void 0 ? void 0 : _h.intId) == 101 ? 'Not Required / Exempt' : item.strRegulationId == null && ((_j = item.objLuCertificationType) === null || _j === void 0 ? void 0 : _j.intId) != 101 ? 'Drafting' : item.strRegulationId != null ? 'View Details' : ''}`,
                    boolSampleInfoAvail: item.boolSampleInfoAvail, // Include the flag
                    boolDocumentTypeAvail: item.boolDocumentTypeAvail, // Include the flag
                    strRegulationId: item.strRegulationId,
                    intRegVersion: item.intRegVersion,
                    intCertTypeId: (_k = item.objLuCertificationType) === null || _k === void 0 ? void 0 : _k.intId,
                    strServiceId: item.strServiceId
                };
            });
            setTableData(newData);
        }
    }, [data]);
    const showDocumentTypeModal = (record) => __awaiter(void 0, void 0, void 0, function* () {
        setModalLoading(true);
        try {
            const documentTypeDetails = yield getBOMServiceDocTypes(record.strServiceId);
            setDtModalData(documentTypeDetails);
            setDtModalVisible(true);
        }
        catch (error) {
            console.error('Failed to fetch additional details:', error);
        }
        finally {
            setModalLoading(false);
        }
    });
    const showSampleInfoModal = (record) => __awaiter(void 0, void 0, void 0, function* () {
        setModalLoading(true);
        try {
            const sampleInfoDetails = yield getServiceSampleInfo(record.strServiceId);
            setSampleInfoModalData(sampleInfoDetails);
            setSiModalVisible(true);
        }
        catch (error) {
            console.error('Failed to fetch additional details:', error);
        }
        finally {
            setModalLoading(false);
        }
    });
    const siColumns = [
        {
            title: 'S.No',
            dataIndex: 'sno',
            key: 'sno',
            render: (_, __, index) => index + 1
        },
        {
            title: 'Sample Condition',
            dataIndex: 'samplecondition',
            key: 'samplecondition',
            //render: (text, record) => record.objLuSampleCondition?.strLongDesc
            render: (text, record) => {
                var _a;
                return (_jsx("div", { style: { userSelect: 'none' }, children: (_a = record.objLuSampleCondition) === null || _a === void 0 ? void 0 : _a.strLongDesc }));
            },
        },
        {
            title: 'Sample Size',
            dataIndex: 'samplesize',
            key: 'samplesize',
            //render: (text, record) => record.intSampleSize
            render: (text, record) => (_jsx("div", { style: { userSelect: 'none' }, children: record.intSampleSize })),
        }
    ];
    const dtColumns = [
        {
            title: 'S.No',
            dataIndex: 'sno',
            key: 'sno',
            render: (_, __, index) => index + 1
        },
        {
            title: 'Document Type',
            dataIndex: 'documenttype',
            key: 'documenttype',
            //render: (text, record) => record.strLongDesc
            render: (text, record) => (_jsx("div", { style: { userSelect: 'none' }, children: record.strLongDesc })),
        }
    ];
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const columns = [
        {
            title: 'Certificate Name',
            width: 120,
            dataIndex: 'certificatename',
            fixed: screens.xs ? false : "left",
            key: 'certificatename'
        },
        {
            title: 'Service Type',
            width: 120,
            dataIndex: 'servicetype',
            fixed: screens.xs ? false : "left",
            key: 'servicetype'
        },
        {
            title: 'Region',
            width: 120,
            dataIndex: 'region',
            key: 'region'
        },
        {
            title: 'Country/Territory',
            width: 120,
            dataIndex: 'country',
            key: 'country'
        },
        {
            title: 'Product Segment/ Sub Segment',
            width: 120,
            dataIndex: 'productsegment',
            key: 'productsegment'
        },
        {
            title: 'Technology',
            width: 140,
            dataIndex: 'technology',
            key: 'technology'
        },
        {
            title: 'Certificate Type',
            dataIndex: 'certificatetype',
            key: 'certificatetype',
            width: 120
        },
        {
            title: 'Sample Information',
            width: 140,
            dataIndex: 'sampleinfo',
            key: 'sampleinfo',
            fixed: screens.xs ? false : "right",
            render: (text, record) => record.boolSampleInfoAvail ? (_jsx("a", { onClick: () => showSampleInfoModal(record), children: text })) : (text)
        },
        {
            title: 'Required Document Types',
            width: 140,
            dataIndex: 'reqdoctype',
            fixed: screens.xs ? false : "right",
            key: 'reqdoctype',
            render: (text, record) => record.boolDocumentTypeAvail ? (_jsx("a", { onClick: () => showDocumentTypeModal(record), children: text })) : (text)
        },
        {
            title: (_jsxs(_Fragment, { children: ["Requirement Summary", ' ', _jsx(Tooltip, { style: { backgroundColor: 'white', color: 'red' }, title: "In case of Drafting, please contact account manager for further support.", children: _jsx("span", { style: { color: 'red' }, children: "*" }) })] })),
            width: 140,
            dataIndex: 'reqsummary',
            fixed: screens.xs ? false : "right",
            key: 'reqsummary',
            render: (text, record) => record.strRegulationId != null ?
                _jsx(Link, { to: `/regulation-information/details/${record.strRegulationId && record.intRegVersion ? btoa(record.strRegulationId.toString() + '-' + record.intRegVersion.toString()) : ''}`, children: text }) : text
        }
    ];
    return (_jsx("div", { style: { userSelect: 'none' }, children: _jsxs(Card, { size: tableDataItem ? 'small' : 'default', style: { borderRadius: '0px' }, title: !tableDataItem ? (_jsxs(Typography.Text, { children: ["Requirement Search Result (Total Records: ", pagination.total, " )"] })) : (`Certificate Details`), children: [_jsx(WatermarkComponent, { children: _jsx(Table, { columns: columns, dataSource: tableDataItem ? [tableDataItem] : tableData, scroll: {
                            x: 1400
                        }, pagination: pagination, size: 'small', style: { borderRadius: '0px' }, loading: loading, onChange: onChange }) }), _jsx(Modal, { title: _jsx("div", { style: { userSelect: 'none' }, children: "Document Type Information" }), open: dtModalVisible, onCancel: () => setDtModalVisible(false), footer: null, width: 800, children: _jsx("div", { style: { userSelect: 'none' }, children: _jsx(WatermarkComponent, { children: _jsx(Table, { columns: dtColumns, dataSource: dtModalData, pagination: {
                                    // Pagination configuration
                                    defaultPageSize: 10,
                                    // showSizeChanger: true,
                                    pageSizeOptions: ['5', '10', '20', '50']
                                }, size: 'small' }) }) }) }), _jsx(Modal, { title: _jsx("div", { style: { userSelect: 'none' }, children: "Sample Information" }), open: siModalVisible, onCancel: () => setSiModalVisible(false), footer: null, width: 800, children: _jsx("div", { style: { userSelect: 'none' }, children: _jsx(WatermarkComponent, { children: _jsx(Table, { columns: siColumns, dataSource: sampleInfoModalData, pagination: {
                                    // Pagination configuration
                                    defaultPageSize: 10,
                                    // showSizeChanger: true,
                                    pageSizeOptions: ['5', '10', '20', '50']
                                }, size: 'small' }) }) }) })] }) }));
};
export default BOMDataTable;
